/**
 * config.js — merged-module API configuration.
 *
 * ACCESS_TOKEN / TENANT_CODE / SERVICE_CODE used to be hardcoded strings
 * copied from a single developer's login response. Hardcoded credentials
 * are a bug: they go stale the moment the token expires and they leak one
 * user's identity into every other user's requests.
 *
 * They have been removed as static constants. Every call site now pulls the
 * *current* value live from sessionDB (populated once at login by
 * `src/utils/api.js` -> `api.setSession()`), so requests always carry the
 * signed-in user's own token and tenant.
 *
 * Only the base URLs remain here, since those are genuinely static config.
 */

/** Gateway root. Override with REACT_APP_API_BASE_URL for local backends. */
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const HRMS_BASE_URL  = `${API_BASE_URL}/saas/hrms`;
export const ESS_BASE_URL   = `${API_BASE_URL}/saas/ess`;
export const LOGIN_URL      = `${API_BASE_URL}/saas/login/token`;
export const PSM_BASE_URL   = `${API_BASE_URL}/saas/psm`;
export const CRM_BASE_URL   = `${API_BASE_URL}/saas/crm`;
export const FSM_BASE_URL   = `${API_BASE_URL}/saas/fsm`;
export const IMS_BASE_URL   = `${API_BASE_URL}/saas/ims`;
